import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../Shared/Redux/store';

const initialState = {
  attendanceDayselected: '',
  classSelected: '',
  attenDanceSwitchMode: false,
};

const attendanceSlice = createSlice({
  name: 'attendance',
  initialState,
  reducers: {
    setAttendanceDayselected: (state, action: PayloadAction<string>) => {
      // Only accept strings - all Date objects should be converted at dispatch points
      state.attendanceDayselected = action.payload;
    },
    setclassSelected: (state, action: PayloadAction<string>) => {
      state.classSelected = action.payload;
    },
    setAttenDanceSwitchMode: (
      state,
      action: PayloadAction<boolean | undefined>
    ) => {
      if (typeof action.payload === 'boolean') {
        state.attenDanceSwitchMode = action.payload;
      } else {
        state.attenDanceSwitchMode = !state.attenDanceSwitchMode;
      }
    },
  },
});

export const selectattendanceDayselected = (state: RootState) =>
  state.attendance.attendanceDayselected;
export const selectclassSelected = (state: RootState) =>
  state.attendance.classSelected;
export const selectsAttenDanceSwitchMode = (state: RootState) =>
  state.attendance.attenDanceSwitchMode;

export const {
  setAttendanceDayselected,
  setclassSelected,
  setAttenDanceSwitchMode,
} = attendanceSlice.actions;
export default attendanceSlice.reducer;
